module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mr3Gb0/tc-custom/9781685502324.jpg?1723950725111",
      "alt": "This image is the cover for the book Queer Relations, Twelve Letters"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Queer Relations, Twelve Letters\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sequel to "), _c('i', [_vm._v("Twelve Letters")]), _c('br'), _c('br'), _vm._v("In the autumn of 1814, the Honourable Percy Havilland is generally content with his sheltered existence in London’s exclusive Mayfair. As a society beau, renowned for his fair and youthful beauty and an object of desire to other well-born gentlemen, Percy is slightly miffed his personal life is not running as seamlessly as he might wish."), _c('br'), _c('br'), _vm._v("His good-natured lover from the spring season, Jo Everett, has inexplicably lost interest, and his replacement, Nathaniel Brooks, is far too hard-headed to be cajoled and manipulated into pandering to Percy’s every whim."), _c('br'), _c('br'), _vm._v("But these trifles are cast into proportion when, out of the blue, a family scandal of immense proportions threatens Percy’s peace of mind and his standing amongst the ton. Fearing rejection or even social banishment, to his surprise, Percy discovers a small, unconventional band of friends, including Jo, who are prepared to stick by him. And more importantly, he finds Nathan is utterly reliable in a crisis."), _c('br'), _c('br'), _vm._v("Will Percy remain spoiled, immature, and pampered? Or can he grow from this disaster to appreciate the value of true friendship? Might he even learn to love?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ellie Thomas\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0